import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import {
  faXmark,
  faEnvelope,
  faPhone,
  faLocationDot,
  faPlay,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,faTwitter,
  faLinkedinIn,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";

function Header() {
  return (
   <>
     <header className="homepage1-body">
      <div id="vl-header-sticky" className="vl-header-area vl-transparent-header">
        <div className="container headerfix">
          <div className="row align-items-center row-bg3">
            
            {/* Logo */}
            <div className="col-lg-2 col-md-6 col-6">
              <div className="vl-logo">
                <a href="#">
                  <img src="/assets/img/chester_logo.png" alt="Logo" />
                </a>
              </div>
            </div>

            {/* Main Menu */}
            <div className="col-lg-7 d-none d-lg-block">
              <div className="vl-main-menu text-center">
                <nav className="vl-mobile-menu-active">
                  <ul>
                    <li>
                      <a href="/">
                        Home
                      </a>
                    </li>

                    {/* Pages */}
                    <li >
                      <a href="/aboutus">
                        About Us
                      </a>
                    </li>

                    {/* Services */}
                    <li>
                      <a href="/services">
                        Services{""}
                        <span>
                          <i className="fa-solid fa-angle-down d-lg-inline d-none"></i>
                        </span>
                      </a>
                      <ul className="sub-menu">
                        <li><a href="/mobile-app-development">Mobile App Development</a></li>
                        <li><a href="/web-development">Web Development</a></li>
                        <li><a href="/ui-ux-design">UI/UX Design</a></li>
                        <li><a href="/digital-marketing">Digital Marketing</a></li>
                        <li><a href="/internet-of-things">Internet of Things</a></li>
                        <li><a href="/cloud-solutions">Cloud Solutions</a></li>
                      </ul>
                    </li>

                    {/* Case Study */}
                    {/* <li>
                      <a href="/portfolio">
                        Portfolio{" "}
                      </a>
                    </li> */}
                    <li>
                      <a href="/career">
                        Career{" "}
                      </a>
                    </li>


                    {/* Contact */}
                    <li><a href="/contact">Contact</a></li>
                  </ul>
                </nav>
              </div>
            </div>

            {/* Buttons */}
            <div className="col-lg-3 col-md-6 col-6">
              <div className="vl-hero-btn d-none d-lg-block text-end">
                <span className="vl-btn-wrap text-end">
                  <a href="/contact" className="vl-btn1">
                    Get Started Now <i className="fa-solid fa-arrow-right"></i>
                  </a>
                </span>
              </div>
              <div className="vl-header-action-item d-block d-lg-none">
                <button type="button" className="vl-offcanvas-toggle">
                  <i className="fa-solid fa-bars-staggered"></i>
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </header>
    {/* ===== MOBILE HEADER STARTS ===== */}
          <div className="homepage1-body">
            <div className="vl-offcanvas">
              <div className="vl-offcanvas-wrapper">
                <div className="vl-offcanvas-header d-flex justify-content-between align-items-center mb-90">
                  <div className="vl-offcanvas-logo">
                    <a href="index.html">
                      <img src="/assets/img/chester_logo.png" alt="logo" />
                    </a>
                  </div>
                  <div className="vl-offcanvas-close">
                    <button className="vl-offcanvas-close-toggle">
                      <FontAwesomeIcon icon={faXmark} />
                    </button>
                  </div>
                </div>
    
                <div className="vl-offcanvas-menu d-lg-none mb-40">
                  <nav></nav>
                </div>
    
                <div className="space20"></div>
                <div className="vl-offcanvas-info">
                  <h3 className="vl-offcanvas-sm-title">Contact Us</h3>
                  <div className="space20"></div>
                  <span>
                    <a href="#">
                      <FontAwesomeIcon icon={faEnvelope} /> 07533139643
                    </a>
                  </span>
                  <span>
                    <a href="#">
                      <FontAwesomeIcon icon={faPhone} /> info@chesteritsolutions.com
                    </a>
                  </span>
                  {/* <span>
                    <a href="#">
                      <FontAwesomeIcon icon={faLocationDot} /> Bhemeara, Kushtia
                    </a>
                  </span> */}
                </div>
    
                <div className="space20"></div>
                <div className="vl-offcanvas-social">
                  <h3 className="vl-offcanvas-sm-title">Follow Us</h3>
                  <div className="space20"></div>
                  <a href="#">
                    <FontAwesomeIcon icon={faFacebookF} />
                  </a>
                  <a href="#">
                    <FontAwesomeIcon icon={faTwitter} />
                  </a>
                  <a href="#">
                    <FontAwesomeIcon icon={faLinkedinIn} />
                  </a>
                  <a href="#">
                    <FontAwesomeIcon icon={faInstagram} />
                  </a>
                </div>
              </div>
            </div>
            <div className="vl-offcanvas-overlay"></div>
          </div>
          {/* ===== MOBILE HEADER ENDS ===== */}
   </>
  )
}

export default Header;
